import Course from './Components/Course/Course';
import Main from './Components/Main';
import React, { Component }  from 'react';
import './App.css';

function App() {
  return (
    <div className="App">
      <Main/>
    </div>
  );
}

export default App;
